import { BagguLogo, BranchLogo, ClickupLogo, EchoLogo, GoDaddyLogo } from '@/components/_rebrand/logos/index';
import { FC } from 'react';

const LogoBar: FC = () => {
  return (
    <div className="hidden md:flex w-full items-center justify-between mt-[54px]">
      <div className="flex items-center">
        <div className="flex flex-wrap text-violet-200 text-caption1">
          <span className="font-500 text-p2 mr-[6px]">
            Trusted by 9,000+
          </span>
          <span className="text-p2">
            companies worldwide
          </span>
        </div>
      </div>
      <div className="flex items-center">
        <div className="flex mr-[20px] 2xl:mr-[70px]">
          {BranchLogo()}
        </div>
        <div className="flex mr-[20px] 2xl:mr-[70px]">
          {EchoLogo()}
        </div>
        <div className="flex mr-[20px] 2xl:mr-[70px]">
          {ClickupLogo()}
        </div>
        <div className="flex mr-[20px] 2xl:mr-[70px]">
          {GoDaddyLogo()}
        </div>
        <div className="flex">
          {BagguLogo()}
        </div>
      </div>
    </div>
  );
};

export default LogoBar;
